import React, { useState, useEffect } from 'react';
import logo from '../images/logo-short.png';

const NAV_LINKS = [
  { label: 'Home',          page: 'Home',          path: '/'              },
  { label: 'About Us',      page: 'About',         path: '/about'         },
  { label: 'Services',      page: 'Services',      path: '/services'      },
  { label: 'Accreditation', page: 'Accreditation', path: '/accreditation' },
  { label: 'Documents',     page: 'Documents',     path: '/documents'     },
  { label: 'Contact Us',    page: 'Contact',       path: '/contact'       },
];

export default function Navbar({ page, navigate }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const go = (pageKey, e) => {
    e.preventDefault();
    navigate(pageKey);
    setOpen(false);
  };

  return (
    <nav
      className={`navbar${scrolled ? ' scrolled' : ''}`}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="nav-inner">
        {/* Logo */}
        <a
          className="logo-wrap"
          href="/"
          onClick={(e) => go('Home', e)}
          aria-label="Assure Quality — Home"
        >
          <img src={logo} height="50" alt="Assure Quality Management Certification Services" />
          <div className="logo-name-block">
            <span className="logo-name">
              <em>Assure</em> Quality
            </span>
            <span className="logo-tagline">Management Certification Services</span>
          </div>
        </a>

        {/* Links */}
        <div className={`nav-links${open ? ' open' : ''}`} role="menubar">
          {NAV_LINKS.map(({ label, page: pg, path }) => (
            <a
              key={pg}
              href={path}
              className={`nav-link${page === pg ? ' active' : ''}`}
              role="menuitem"
              onClick={(e) => go(pg, e)}
              aria-current={page === pg ? 'page' : undefined}
            >
              {label}
            </a>
          ))}
          <a
            href="/contact"
            className="nav-link nav-cta"
            onClick={(e) => go('Contact', e)}
          >
            Get Certified →
          </a>
        </div>

        {/* Hamburger */}
        <button
          className={`hamburger${open ? ' open' : ''}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </nav>
  );
}
